var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2036 117.9C48.4496 119 61.7227 125.237 69.5458 129.769C74.1715 132.448 79.8285 132.448 84.4542 129.769C92.2774 125.237 105.55 119 120.796 117.9C128.594 117.339 134.75 111.096 134.75 103.279V36.9196C134.75 28.1167 127.046 21.3678 118.299 22.3229C104.108 23.8775 91.8462 29.6775 84.4542 33.9666C79.8285 36.6449 74.1715 36.6449 69.5458 33.9666C62.1536 29.6775 49.8918 23.8775 35.7009 22.3229C26.9479 21.3678 19.25 28.1167 19.25 36.9196V103.279C19.25 111.096 25.4058 117.339 33.2036 117.9Z",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37.723V131.415",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.968 23.1978V59.9111L110.459 57.5824C107.163 55.3972 102.88 55.3972 99.5838 57.5824L96.0752 59.9111V28.2049",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7061 91.7115L112.728 86.1489",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0765 62.8365L40.0542 57.2737M54.0765 91.6929L40.0542 86.1303",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionPlaceholder);
export default __webpack_public_path__ + "static/media/SessionPlaceholder.a2ffd7c1897e05237637af64063a6bfa.svg";
export { ForwardRef as ReactComponent };